module.exports = __webpack_public_path__ + "static/img/logo_pink.a03f628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_pink.png
// module id = lq6E
// module chunks = 1